import { StringOrNumber } from 'src/app/core';
import { LearningJourneyProgressionRoutesConfig } from './learning-journey-progression-routes.config';

export class LearningJourneyProgressionRoutes {
	public static LJ_HOME_ROUTE = LearningJourneyProgressionRoutesConfig.LJ_BASE_URL;
	public static LJ_PROGRESSION_HOME_ROUTE = LearningJourneyProgressionRoutesConfig.LJ_PROGRESSION_BASE_URL;
	public static USERS_ROUTE = 'users';
	public static LJ_PROGRESSION_CONTENT_DETAILS_ROUTE =
		LearningJourneyProgressionRoutesConfig.LJ_PROGRESSION_CONTENT_DETAILS_SEGMENT;
	public static LJ_PROGRESSION_DETAILS_ROUTE =
		LearningJourneyProgressionRoutesConfig.LJ_PROGRESSION_DETAILS_ID_VERSION_USER_ENROLLMENT_SEGMENT;

	public static getLJProgressionDetailsRoute(
		workflowId: StringOrNumber,
		versionId: StringOrNumber,
		userId: number,
		enrollmentId: string
	): string {
		return `${LearningJourneyProgressionRoutesConfig.LJ_PROGRESSION_BASE_URL}/${workflowId}/${versionId}/${userId}/${enrollmentId}`;
	}
}
